import { render, staticRenderFns } from "./ByCustomer.vue?vue&type=template&id=18461af2&scoped=true&"
import script from "./ByCustomer.vue?vue&type=script&lang=js&"
export * from "./ByCustomer.vue?vue&type=script&lang=js&"
import style0 from "./ByCustomer.vue?vue&type=style&index=0&id=18461af2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18461af2",
  null
  
)

export default component.exports